import { Box, Stack } from "@mui/material"
import React from "react"
import { LabelAndText } from "../../components/Typography/Typography"
import { FlightlineEventReview } from "../../models/MissionReview"
import { reviewDrawerMinWidth } from "../../utils/MissionReviewUtils"
import { TimeUtils } from "../../utils/TimeUtils"
import { convertLengthUnits } from "../../utils/UnitCalculations"
import { useLocalStorageStore } from "../../zstore/LocalStorageStore"

interface Detail {
    label: string
    value?: string | number
}

export const ReviewDrawerFlightlineDetails = React.memo(
    ({
        review,
    }: {
        review: FlightlineEventReview
    }) => {
        const prefDistanceUnit = useLocalStorageStore((state) => state.preferredDistanceUnit)
        const prefHeightUnit = useLocalStorageStore((state) => state.preferredHeightUnit)
        const event = review.event

        const eventDetails: Detail[] = [
            { label: "Original Name", value: event.line_original_name },
            {
                label: "Linked Planned Lines",
                value: review.flightplan_name_long_label,
            },
            { label: "Sensor Label", value: event.coll_event_name },
            { label: "Operator Status", value: event.flight_status },
            { label: "Start Time", value: TimeUtils.formatTime(event.flight_line_start_time) },
            { label: "Stop Time", value: TimeUtils.formatTime(event.flight_line_stop_time) },
            { label: "Duration (s)", value: event.flight_line_duration },
            {
                label: `Flight Line AGL (${prefHeightUnit})`,
                value: convertLengthUnits(event.flown_agl, prefHeightUnit),
            },
            {
                label: `Flight Line Length (${prefDistanceUnit})`,
                value: convertLengthUnits(event.flight_line_distance, prefDistanceUnit),
            },
        ]

        return (
            <Stack sx={{ width: reviewDrawerMinWidth }}>
                {eventDetails.map((detail, idx) => (
                    <LabelAndText key={idx} label={detail.label}>
                        {detail.value ?? ""}
                    </LabelAndText>
                ))}
                <LabelAndText label="Operator Notes">{event.notes ?? "None"}</LabelAndText>
                {event.sensor_details && (
                    <Box sx={{ p: 2 }}>
                        {Object.entries(JSON.parse(event.sensor_details)).map(([key, value]) => (
                            <LabelAndText key={key} label={key}>
                                {typeof value === "number" || typeof value === "string" ? value : ""}
                            </LabelAndText>
                        ))}
                    </Box>
                )}
            </Stack>
        )
    },
)
